import Component from "../../classes/Component";
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";

const {removeClass, addClass, hasClass} = $dom

const adaptiveGroupSelector = '.js-group-adaptive'
const buttonBackSelector = '.js-button-back-adaptive'
const buttonNextSelector = '.js-button-next-adaptive'

const nonactiveBlock = 'bucket__form-block-nonactive'
const activeBlock = 'bucket__form-block-active'

export default function () {
    const handleGoBack = (e) => {
        if (hasClass(e.target, buttonBackSelector.slice(1))) {
            addClass(e.target.closest(adaptiveGroupSelector).previousElementSibling, activeBlock)
            removeClass(e.target.closest(adaptiveGroupSelector).previousElementSibling, nonactiveBlock)
            removeClass(e.target.closest(adaptiveGroupSelector), activeBlock)
            addClass(e.target.closest(adaptiveGroupSelector), nonactiveBlock)
        }

    }

    const handleGoNext = (e) => {
        if (hasClass(e.target, buttonNextSelector.slice(1))) {
            addClass(e.target.closest(adaptiveGroupSelector).nextElementSibling, activeBlock)
            removeClass(e.target.closest(adaptiveGroupSelector).nextElementSibling, nonactiveBlock)
            removeClass(e.target.closest(adaptiveGroupSelector), activeBlock)
            addClass(e.target.closest(adaptiveGroupSelector), nonactiveBlock)
        }

    }

    return new Component({
        name: 'adaptive',
        requiredTargets: [
            adaptiveGroupSelector,
            buttonBackSelector,
            buttonNextSelector,
        ],
        onInit() {
            $events.delegate
                .on('click', buttonBackSelector, handleGoBack)
                .on('click', buttonNextSelector, handleGoNext)
        },
        onDestroy() {
            $events.delegate
                .off('click', buttonBackSelector, handleGoBack)
                .off('click', buttonNextSelector, handleGoNext)
        },
    })

}